import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const VpPageTitle = ({ title, subTitle }) => {
  return (
    <Stack spacing="5px">
      {title && <Typography variant="pageTitle">{title}</Typography>}
      {subTitle && <Typography variant="pageSubTitle">{subTitle}</Typography>}
    </Stack>
  );
};

VpPageTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default VpPageTitle;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPageTitle/VpPageTitle.jsx